import { indexPreface } from "@/components/ExperiencePage/Algolia/constants.js";
import ProgramsIcon from "@/components/shared/icons/ProgramManagerNavIcons/ProgramsIcon.vue";
import ProgramSessionsIcon from "@/components/shared/icons/ProgramManagerNavIcons/ProgramSessionsIcon.vue";
import HousingIcon from "@/components/shared/icons/ProgramManagerNavIcons/HousingIcon.vue";
import InternshipsIcon from "@/components/shared/icons/ProgramManagerNavIcons/InternshipsIcon.vue";
import ExcursionEventsIcon from "@/components/shared/icons/ProgramManagerNavIcons/ExcursionEventsIcon.vue";
import ClassesIcon from "@/components/shared/icons/ProgramManagerNavIcons/ClassesIcon.vue";
import { hasProgramsReadLitePermission, hasItemsPermissionProgramManager } from "@/composables/authorization.js";
import { PROGRAM_MANAGER_V2_ROUTES } from "@/constants";

export const PROGRAM_MANAGER_SESSION_INDEX = `${indexPreface}_program_manager_sessions`;

export const PROGRAM_MANAGER_LINKS = [
  {
    id: "programs-link",
    label: "Programs",
    icon: ProgramsIcon,
    route: PROGRAM_MANAGER_V2_ROUTES.PROGRAMS,
    visible: () => hasProgramsReadLitePermission(),
  },
  {
    id: "program-sessions-link",
    label: "Program Sessions",
    icon: ProgramSessionsIcon,
    route: PROGRAM_MANAGER_V2_ROUTES.PROGRAM_SESSIONS,
    visible: () => hasProgramsReadLitePermission(),
  },
  {
    id: "housing-link",
    label: "Housing",
    icon: HousingIcon,
    route: PROGRAM_MANAGER_V2_ROUTES.HOUSING,
    visible: () => hasItemsPermissionProgramManager(),
  },
  {
    id: "internships-link",
    label: "Internships",
    icon: InternshipsIcon,
    route: PROGRAM_MANAGER_V2_ROUTES.INTERNSHIPS,
    visible: () => hasItemsPermissionProgramManager(),
  },
  {
    id: "excursions-events-link",
    label: "Excursions + Events",
    icon: ExcursionEventsIcon,
    route: PROGRAM_MANAGER_V2_ROUTES.EXCURSIONS_EVENTS,
    visible: () => hasItemsPermissionProgramManager(),
  },
  {
    id: "classes-link",
    label: "Classes",
    icon: ClassesIcon,
    route: PROGRAM_MANAGER_V2_ROUTES.CLASSES,
    visible: () => hasItemsPermissionProgramManager(),
  },
];

export const SESSION_FILTER_TABS = {
  MY_SESSIONS: 'my-sessions',
  CATALOG_SESSIONS: 'catalog-sessions',
  HIDDEN_SESSIONS: 'hidden-sessions'
}
